import { Link } from "react-router-dom";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon";
import { Phone, CalendarDays } from "lucide-react";
import { getWhatsAppUrl, PHONE_PRIMARY_TEL, PHONE_PRIMARY, WHATSAPP_BOOKING_INTRO } from "@/lib/constants";
import { trackCall, trackWhatsApp, track } from "@/lib/analytics";

const WhatsAppButton = () => (
  <>
    <Link
      to="/book-appointment"
      onClick={() => track("book_appointment_click", { source: "floating" })}
      className="hidden md:flex fixed bottom-52 md:bottom-40 right-4 z-[9999] h-14 w-14 rounded-full bg-gold text-foreground flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      aria-label="Book appointment"
    >
      <CalendarDays className="h-7 w-7" />
    </Link>
    <a
      href={PHONE_PRIMARY_TEL}
      onClick={() => trackCall("floating")}
      className="hidden md:flex fixed bottom-36 md:bottom-24 right-4 z-[9999] h-14 w-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      aria-label={`Call ${PHONE_PRIMARY}`}
    >
      <Phone className="h-7 w-7" />
    </a>
  <a
    href={getWhatsAppUrl(WHATSAPP_BOOKING_INTRO)}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackWhatsApp("floating")}
    className="hidden md:flex fixed bottom-20 md:bottom-6 right-4 z-[9999] h-14 w-14 rounded-full bg-whatsapp text-whatsapp-foreground flex items-center justify-center shadow-lg hover:scale-110 transition-transform animate-whatsapp-pulse"
    aria-label="Chat on WhatsApp"
  >
    <WhatsAppIcon className="h-7 w-7" />
  </a>
  </>
);

export default WhatsAppButton;
